import siteSearchPreset from '../item-types/static-page-v2/schema-presets/site_search';
export var getSiteSearchSlug = function (installedApps) {
    var _a;
    if (installedApps === void 0) { installedApps = []; }
    return (_a = installedApps.find(function (app) {
        return app.appDefinitionId === siteSearchPreset.appDefId ||
            app.tpaPageId === siteSearchPreset.tpaPageId;
    })) === null || _a === void 0 ? void 0 : _a.pageUriSEO;
};
